var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRotateRight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/linear/rotate-right"
  }, /*#__PURE__*/React.createElement("g", {
    id: "rotate-right"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11.0842 7.12497C12.2699 6.5334 13.6078 6.20054 15.0236 6.20054C17.2604 6.20054 19.3027 7.03134 20.8575 8.40054H19.4335C18.8246 8.40054 18.331 8.89302 18.331 9.50054C18.331 10.1081 18.8246 10.6005 19.4335 10.6005H24.0285C24.6374 10.6005 25.1309 10.1081 25.1309 9.50054V5.09939C25.1309 4.49251 24.6379 4.00054 24.0296 4.00054C23.4214 4.00054 22.9283 4.49251 22.9283 5.09939V7.33272C22.712 7.11081 22.4865 6.89798 22.2522 6.69485L22.2516 6.69284C20.3164 5.0154 17.7894 4 15.0247 4C13.2508 4 11.5747 4.41802 10.0901 5.16072C6.47881 6.96727 4 10.6948 4 15C4 21.0751 8.93592 26 15.0247 26C20.7419 26 25.4427 21.6579 25.9951 16.0985C26.0552 15.4939 25.5558 15 24.9469 15C24.338 15 23.8517 15.495 23.7765 16.0978C23.2349 20.4398 19.5231 23.8 15.0247 23.8C10.1537 23.8 6.20494 19.8601 6.20494 15C6.20494 11.553 8.19128 8.56885 11.0842 7.12497Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRotateRight);
export default __webpack_public_path__ + "static/media/rotate-right.c039cdc67c7c6ae4dfe8f3310e1d63cc.svg";
export { ForwardRef as ReactComponent };